import React, {ReactNode, useEffect, useRef} from 'react'
import {useLocation} from 'react-router-dom'

interface Props {
    children: ReactNode;
}

export const ScrollToTop: React.FC<Props> = ({children}) => {
    const isFirstRender = useRef(true)
    const location = useLocation()
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false
        } else {
            window.scrollTo(0, 0)
        }
    }, [location.pathname])

    return <>{children}</>
}
